import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import Dispatch from '@vaersaagod/tools/Dispatch';
import * as events from '../lib/events';

export default (el, props) => {
    const $el = $(el);

    const $visuals = $el.find('.parallax-visual');
    const visuals = $visuals.get();
    const $content = $el.find('.parallax-content');
    const content = $content.get();

    const factor = (props || {}).factor || 1.7;

    let stageH;
    let timeline;
    let scrollLocked = false;

    const createTimeline = () => {
        timeline = new TimelineLite({
            paused: true,
            useFrames: true
        });

        if (content.length) {
            timeline
                .to(content, stageH * 0.4, {
                    opacity: 0,
                    ease: Linear.easeNone
                }, 0)
                .to(content, stageH * 0.5, {
                    y: stageH * 0.1,
                    ease: Linear.easeNone
                }, 0);
        }
        if (visuals.length) {
            timeline
                .fromTo(visuals, stageH, {
                    yPercent: 0
                }, {
                    yPercent: ((stageH * factor) / 100),
                    ease: Linear.easeNone
                }, 0);
        }
    };

    const onScroll = () => {
        if (scrollLocked) {
            return;
        }

        if (!timeline) {
            createTimeline();
        }

        timeline.progress(Math.max(0, Math.min(Viewport.scrollTop / timeline.duration(), 1)));
    };

    const onResize = () => {
        if (scrollLocked) {
            return;
        }
        if (timeline) {
            timeline.kill();
        }
        stageH = Viewport.height;
    };

    const onBeforeScrollLocked = () => {
        scrollLocked = true;
    };

    const onAfterScrollReleased = () => {
        scrollLocked = false;
    };

    const init = () => {
        if (!content.length && !visuals.length) {
            return;
        }
        $visuals.css({
            willChange: 'transform'
        });
        $content.css({
            willChange: 'opacity'
        });
        Viewport.on('resize', onResize);
        Viewport.on('scroll', onScroll);
        Dispatch.on(events.BEFORE_SCROLL_LOCKED, onBeforeScrollLocked);
        Dispatch.on(events.SCROLL_RELEASED, onAfterScrollReleased);
        onResize();
        createTimeline();
        onScroll();
    };

    const destroy = () => {
        if (!content.length && !visuals.length) {
            return;
        }
        Viewport.off('scroll', onScroll);
        Viewport.off('resize', onResize);
        Dispatch.off(events.BEFORE_SCROLL_LOCKED, onBeforeScrollLocked);
        Dispatch.off(events.SCROLL_RELEASED, onAfterScrollReleased);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Parallaxer.js